import { Link } from 'react-router';
import { Page } from '../components/AppShell';
import { EmptyState, ScreenHeader } from '../components/ui';

export function NotFoundPage() {
  return (
    <>
      <ScreenHeader title="Not found" back="/" />
      <Page>
        <EmptyState
          title="Nothing here"
          body={
            <>
              That page doesn’t exist. <Link to="/">Go home</Link>.
            </>
          }
        />
      </Page>
    </>
  );
}
